/**
 * Data una classe con un costruttuore, ritorna una funzione
 * che prende in ingresso gli argomenti del costruttore e
 * ritorna l'istanza della classe.
 * Utile per la creazione di chained builders
 */
export function makeBuilder<T extends new (...args: any[]) => any>(
  type: T,
): (...args: ConstructorParameters<T>) => InstanceType<T> {
  return (...args: ConstructorParameters<T>) => new type(...args);
}
